import { CdkDragPlaceholder } from "@angular/cdk/drag-drop";
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// Primeng modules
import { AccordionModule } from 'primeng/accordion';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { FullCalendarModule } from '@fullcalendar/angular';
import { InputTextModule } from 'primeng/inputtext';
import { KnobModule } from 'primeng/knob';
import { PanelModule } from 'primeng/panel';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
// Shared Modules
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { SharedModule } from '../shared/shared.module';
// Components
import { PinComponent } from './components/pin/pin.component';
import { PinPadComponent } from './components/pin-pad/pin-pad.component';
import { SendCommandComponent } from './components/send-command/send-command.component';

@NgModule({
	declarations: [
		PinComponent,
		PinPadComponent,
		SendCommandComponent,
	],
	imports: [
		AccordionModule,
		BlockableDivModule,
		BlockUIModule,
		ButtonModule,
		CdkDragPlaceholder,
		CdkTreeModule,
		CommonModule,
		FullCalendarModule,
		FormsModule,
		InputTextModule,
		KnobModule,
		PanelModule,
		ReactiveFormsModule,
		RouterModule,
		SharedModule,
		StepsModule,
		TableModule,
		TabViewModule,
		TagModule,
	],
	exports: [
		PinComponent,
		PinPadComponent,
		SendCommandComponent,
	]
})
export class AccessCompModule { }
